// Hook leggero per sapere se l'utente ha un account Microsoft connesso.
// Speculare al gate di useMicrosoftAccount (connected = flag + refresh_token +
// microsoft_user_id) ma SENZA effetti collaterali (niente fetch calendari): pensato
// per il gating dei componenti mail Outlook (pagina/drawer sempre montato).
import { useEffect, useState } from 'react';
import { supabase } from '../supabase';

export function useMicrosoftConnected(userId: string | undefined) {
  const [connected, setConnected] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    if (!userId) {
      setConnected(false);
      setLoading(false);
      return;
    }
    setLoading(true);
    supabase
      .from('user_profiles')
      .select('microsoft_account_connected, microsoft_refresh_token, microsoft_user_id')
      .eq('id', userId)
      .single()
      .then(({ data, error }) => {
        if (cancelled) return;
        const ok = !error && !!data?.microsoft_account_connected &&
          !!data?.microsoft_refresh_token && !!data?.microsoft_user_id;
        setConnected(ok);
        setLoading(false);
      });
    return () => { cancelled = true; };
  }, [userId]);

  return { connected, loading };
}
